
import { ControllerRelatorioDiretivo } from '@/api/gerencial/RequestRelatorioDiretivoDTO';
import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';
import { RelatorioDiretivoModel } from '@/models/administracao/diretivo/RelatorioDiretivoModel';

export default class GerencialDiretivoService {

    static gerarRelatorio(tipo: string, request: RelatorioDiretivoModel) {
        return integracaoContabilApi.gerarRelatorioDiretivo(tipo, ControllerRelatorioDiretivo.convertToDTO(request));
    }

    static diretivoDados(request: RelatorioDiretivoModel) {
        return integracaoContabilApi.diretivoDados(ControllerRelatorioDiretivo.convertToDTO(request));
    }
    
}